import { Box } from '@mui/joy';
import ControlPanelLayout from '../Controls/ControlPanelLayout';
import { Country } from '../Country/Country';
import { useRoute } from '../../providers/RouteProvider';
import { TEN_STATE_OPTIONS, TEN_STATE_STATE_OPTIONS } from '../../lib/const';

export const StateViewHighlights = () => {
	const { selectedState, setSelectedState, election } = useRoute();
	return (
		<Box
			sx={{
				width: { xs: '295px', sm: '325.45px', md: '512px' }
			}}
		>
			<ControlPanelLayout
				page='state'
				selectOnly
				selectSx={{
					backgroundColor: '#FFFFFF',
					margin: 0,
					padding: 0,
					marginBottom: '44px'
				}}
			/>
			<Box
				sx={{
					height: '100%',
					width: { xs: '295px', sm: '325.45px', md: '452.11px' }
				}}
			>
				<Country
					active={selectedState ? [selectedState.toUpperCase()] : undefined}
					activeColor='candidates'
					available={
						election === 'state'
							? TEN_STATE_STATE_OPTIONS.map((state) => state.id.toUpperCase())
							: TEN_STATE_OPTIONS.map((state) => state.id.toUpperCase())
					}
					includeLabels
					onStateClick={setSelectedState}
				/>
			</Box>
		</Box>
	);
};
